'use client';

import dynamic from 'next/dynamic';
import { useSession } from 'next-auth/react';
import { useUser } from '@/lib/contexts/user-context';

const IntercomMessengerLoader = dynamic(
  () =>
    import('./intercom-messenger-loader').then(
      (m) => m.IntercomMessengerLoader
    ),
  { ssr: false }
);

export function IntercomMessenger() {
  const { status } = useSession();
  const { user } = useUser();

  if (status !== 'authenticated' || !user) return null;

  return <IntercomMessengerLoader user={user} />;
}
